import axios from './authService';
import { API_ENDPOINTS } from '../config/apiConfig';

export async function getMarkets() {
  const response = await axios.get(API_ENDPOINTS.GET_MARKETS);
  const raw = response.data?.data ?? response.data ?? [];
  const items = Array.isArray(raw) ? raw : [];

  return items.map((m) => ({
    id: m.id,
    name: m.name,
  }));
}
